import React from 'react';
import 'js/polyfills';
import 'js/pageComponents';
import 'intersection-observer';
import 'js/components/tagTypes';
import { store } from 'js/store';
import { Provider } from 'react-redux';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { Router } from 'js/components/system/Router';
import { WrapperRouter } from 'js/components/system/WrapperRouter';

import 'styles/main.scss';

export const renderApp = ({ container, isWrapper }) => {
    const App = (
        <SnackbarProvider maxSnack={5}>
            <Provider store={store}>
                {isWrapper ? <WrapperRouter /> : <Router />}
            </Provider>
        </SnackbarProvider>
    );

    if (container.dataset.serverRendered) {
        hydrateRoot(container, App);

        return null;
    }

    const root = createRoot(container);

    root.render(App);

    return null;
};

export * from 'js/backbone/exports';
